import "reflect-metadata";
import { AppProps } from "next/app";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import "../assets/_libs/style/base/_reset.scss";
import "../assets/_libs/style/base/_common.scss"
import "../assets/_libs/style/base/_root.scss";
// import "../assets/_libs/style/general/_all.scss";
import "../assets/_libs/style/general/_body.scss";
import "../assets/_libs/style/general/_button.scss";
import "../assets/_libs/style/general/_html.scss";
// import "tailwindcss/tailwind.css";
import 'material-icons/iconfont/material-icons.scss';


export default function App({ Component, pageProps }: AppProps) {
  // Registry();
  const router = useRouter();
  const route = router.route;
  const [isRender, setIsRender] = useState(false);

  useEffect(() => {
    setIsRender(true);
    // NOTE: ページ遷移時にisRenderを初期化する。リロードでないページ遷移時にisRenderがtrueのままになるため
    const handleRouteChange = () => {
      setIsRender(false);
    };
    // ページ遷移時のイベント
    router.events.on("routeChangeStart", handleRouteChange);
    // イベントの削除(不要なイベントリスナーが残り続けて無駄に実行されるメモリリーク問題を防ぐ
    return () => {
      router.events.off("routeChangeStart", handleRouteChange);
    };
  }, [route]);
  // @ts-ignore
  return isRender && <Component {...pageProps} />;
}
